// extracted by mini-css-extract-plugin
export default {"container":"ProcoDocsItem_container__QIcaF","sidebar_row":"ProcoDocsItem_sidebar_row__3UcFB"};